export default __webpack_public_path__ + "static/2010-4-815c3ce526d24332109fb883d39c9a2d.jpg";